import { put } from "redux-saga/effects";
import axios from "../../axios-local-api";
import * as actions from "../actions";

export function* initBroadcastSettingsSaga() {
  try {
    const response = yield axios.get("/broadcastSettings");
    if (response?.status === 200) {
      yield put(actions.setBroadcastSettings(response?.data));
    } else {
      yield put(actions.fetchBroadcastSettingsFailed());
    }
  } catch (error) {
    yield put(actions.fetchBroadcastSettingsFailed());
  }
}
